import { scrubSecretSantaUrls } from '#src/analytics/posthog/scrub_secret_santa_urls.ts';
import posthog from 'posthog-js';

let isInitialized = false;

export function initPosthog(config: PosthogConfig): void {
  if (!config.enabled || isInitialized) {
    return;
  }

  posthog.init(config.key, {
    debug: config.debug,
    api_host: config.apiHost,
    ui_host: config.uiHost,
    persistence: 'sessionStorage',
    person_profiles: 'never',
    capture_pageview: 'history_change',
    capture_pageleave: 'if_capture_pageview',
    enable_heatmaps: false,
    disable_session_recording: true,
    autocapture: false,
    capture_performance: false,
    capture_exceptions: false,
    disable_surveys: true,
    defaults: '2025-05-24',
    sanitize_properties: scrubSecretSantaUrls,
  });
  isInitialized = true;
}

export interface PosthogConfig {
  enabled: boolean;
  debug: boolean;
  uiHost: string;
  apiHost: string;
  key: string;
}
